import React from 'react';
import Icon from '../../../components/AppIcon';

const RiskMetricsCard = ({ title, value, change, changeType, icon, threshold, status }) => {
  const getStatusColor = () => {
    switch (status) {
      case 'critical':
        return 'text-error bg-error/10 border-error/20';
      case 'warning':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'good':
        return 'text-success bg-success/10 border-success/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-success';
    if (changeType === 'negative') return 'text-error';
    return 'text-muted-foreground';
  };

  return (
    <div className={`bg-card border rounded-lg p-4 ${getStatusColor()}`}>
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center space-x-2">
          <Icon name={icon} size={16} className="text-current" />
          <span className="text-sm font-medium">{title}</span>
        </div>
        {threshold && (
          <span className="text-xs px-2 py-1 bg-muted rounded">
            Limit: {threshold}
          </span>
        )}
      </div>
      
      <div className="space-y-1">
        <div className="text-2xl font-bold text-foreground">{value}</div>
        {change && (
          <div className={`flex items-center space-x-1 text-sm ${getChangeColor()}`}>
            <Icon 
              name={changeType === 'positive' ? 'TrendingUp' : changeType === 'negative' ? 'TrendingDown' : 'Minus'} 
              size={14} 
            />
            <span>{change}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default RiskMetricsCard;